export default __webpack_public_path__ + "static/media/3.ae9d6ca3.jpg";